import React from "react";
import styles from "./style.module.css";
import limitedoffer from "../../../assets/images/limitedoffer.png";

function Promobanner() {
  return (
    <div className={`${styles.promoblock}`}>
      <div className="row align-items-center">
        <div className="col-lg-6">
      <div className={`${styles.promobanner}`}>
      {/* Left Side: Video */}
        
          
            <div className={styles.promovideo}>
              <video autoPlay muted loop playsInline>
                <source src="/videos/trevel.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
        {/* Right Side: Content */}
          <div className={styles.promocontent}>
            <p className={styles.offer}>
                <i><img src={limitedoffer} alt="" className="img-fluid"/></i>
            </p>
            <h2 className={styles.title}>
              Unlock Your Free Data!{" "}
              <span className={styles.highlight}>2GB for 3 Days</span>
              <br /> — Just for GlobalTix Users!
            </h2>
            <p className={styles.description}>
              Start your journey with complimentary data. Explore our eSIMs
              top-up,<br className="d-lg-block d-none"/> and enjoy seamless connectivity wherever you travel!
            </p>
            <button className={styles.ctabtn}>Claim 1GB Data</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Promobanner;
